import { render } from "./FrequentlyReports.vue?vue&type=template&id=c36b7b34&scoped=true&ts=true"
import script from "./FrequentlyReports.vue?vue&type=script&lang=ts"
export * from "./FrequentlyReports.vue?vue&type=script&lang=ts"

import "./FrequentlyReports.vue?vue&type=style&index=0&id=c36b7b34&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36b7b34"]])

export default __exports__